//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Popup, Field, Toast } from 'vant'
import { getBaseTime, firstJoinPanduan, firstJoin } from '@/api/shuping'
import { getAddressDefault, addAddress, editAddress } from '@/api/user'
import coutDown from './vue2-countdown'
export default {
  components: {
    [Popup.name]: Popup,
    [Field.name]: Field,
    coutDown
  },
  props: {},
  data () {
    return {
      id: this.$route.params.id,
      partyid: this.$route.params.partyid,
      obj: '',
      isfirsttime: false,
      show: false,
      name: '',
      area: '',
      mobile: '',
      defautAddress: false,
      startTime: '',
      endTime: '',
      currentTime: new Date().getTime(),
      addressid: '',
      tipText: '',
      tipTextEnd: '',
      endText: ''
    }
  },
  created () {
    this.gettime()
    this.judge()
    this.getaddress()
  },
  watch: {
    isfirsttime: function (val) {
      if (val) {
        this.show = true
      }
    },
    '$route.name' () {
      this.getstatus()
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    userid () {
      return this.$store.state.user.userid
    }
  },
  mounted () { },
  methods: {
    getaddress () {
      getAddressDefault({
        accountid: this.accountid,
        userid: this.userid
      }).then(res => {
        if (res.status === 'suc') {
          if (res.returnValue !== '') {
            this.defautAddress = true
            this.name = res.returnValue.NAME
            this.mobile = res.returnValue.MOBILE
            this.area = res.returnValue.ADDRESS
            this.addressid = res.returnValue.ID
          } else {
            this.addressValue.splice(0, this.addressValue.length)
            this.defautAddress = false
          }
        }
      })
    },
    gettime () {
      getBaseTime(
        { id: this.id }
      ).then(res => {
        this.obj = res.obj
        this.getstatus()
      })
    },
    getstatus () {
      this.tipText = '距离活动开始时间'
      this.tipTextEnd = '距离活动结束时间'
      this.endText = '活动已结束'
      this.startTime = this.obj.startdate.replace(/-/g, '/')
      this.endTime = this.obj.enddate.replace(/-/g, '/')
      // console.log(new Date(this.startTime).getTime())
      // console.log(new Date(this.endTime).getTime())
      // console.log(this.currentTime)
    },
    judge () {
      firstJoinPanduan({
        accountid: this.accountid,
        numberid: this.id
      }).then(res => {
        if (res.obj) {
          this.isfirsttime = true
        }
      })
    },
    submit () {
      if (this.name == '') {
        Toast('请输入姓名')
        return false
      } else if (this.area == '') {
        Toast('请输入详细地址')
        return false
      } else if (this.mobile == '') {
        Toast('请输入手机号')
        return false
      }
      if (!this.defautAddress) {
        addAddress({
          accountid: this.accountid,
          openid: this.userid,
          name: this.name,
          mobile: this.mobile,
          address: this.area,
          isdefault: 1
        }).then(data => {
          if (data.status == 'suc') {
            firstJoin({
              accountid: this.accountid,
              numberid: this.id
            }).then(res => {
              if (res.success) {
                this.isfirsttime = false
              }
            })
          }
        })
      } else {
        editAddress({
          addressid: this.addressid,
          accountid: this.accountid,
          openid: this.userid,
          name: this.name,
          mobile: this.mobile,
          address: this.area,
          isdefault: 1
        }).then(data => {
          if (data.status == 'suc') {
            firstJoin({
              accountid: this.accountid,
              numberid: this.id
            }).then(res => {
              if (res.success) {
                this.isfirsttime = false
              }
            })
          }
        })
      }
    }
  }
}
